import 'prop-types';
import { formatCurrency } from '@atc/string-fns';
import 'react';
import { Text, OverlayTrigger, Glyphicon, Popover } from 'reaxl';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
const renderPrice = (label, value, priceIndicator) => !!value && /*#__PURE__*/jsxs("li", {
  className: "display-flex justify-content-between align-items-center padding-vertical-1",
  children: [/*#__PURE__*/jsx(Text, {
    size: 400,
    children: label
  }), /*#__PURE__*/jsxs(Text, {
    size: 400,
    children: [priceIndicator, " ", formatCurrency(value)]
  })]
});
function Tooltip(_ref) {
  let {
    title,
    isDealerAdjustment
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [title, /*#__PURE__*/jsx(OverlayTrigger, {
      overlay: /*#__PURE__*/jsx(Popover, {
        id: "offerspopover",
        children: isDealerAdjustment ? 'Dealer Adjustment reflects either added equipment, a high-demand vehicle selling for above MSRP or both. Ask your dealer for details.' : 'Incentives that only certain buyers might qualify for based on current dealer offers. Ask your dealer for details.'
      }),
      trigger: "click",
      placement: "right",
      rootClose: true,
      children: /*#__PURE__*/jsx(Glyphicon, {
        glyph: "info",
        className: "text-link margin-left-1"
      })
    })]
  });
}
function PricingBreakdown(_ref2) {
  let {
    incentivesEmailCTA,
    hasOffers,
    pricingDetail,
    hideMsrp = false,
    disableIncentives = false,
    enableOfferUpgrades = true
  } = _ref2;
  if (!pricingDetail) {
    return null;
  }
  const {
    dealerAskingPrice,
    listingPrice,
    manufacturerOffer,
    msrp,
    offersUpgrades
  } = pricingDetail;
  let priceIndicator = '-';
  let tooltipProps = {
    title: 'Dealer Discount'
  };
  if (offersUpgrades < 0) {
    priceIndicator = '+';
    tooltipProps = {
      title: 'Dealer Adjustment',
      isDealerAdjustment: true
    };
  }
  return /*#__PURE__*/jsxs("ul", {
    className: "list-unstyled",
    "data-cmp": "pricingBreakdown",
    children: [renderPrice('Dealer Asking Price', dealerAskingPrice), !hideMsrp && renderPrice('MSRP', msrp), !disableIncentives && renderPrice('Applied Offers', manufacturerOffer, '-'), enableOfferUpgrades && renderPrice(/*#__PURE__*/jsx(Tooltip, {
      ...tooltipProps
    }), Math.abs(offersUpgrades), priceIndicator), !!incentivesEmailCTA && hasOffers && incentivesEmailCTA, renderPrice('Listing Price', listingPrice)]
  });
}
export { PricingBreakdown as default };
